import ReactEChartsCore from 'echarts-for-react/lib/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import { useRef } from 'react';

import numberHumanizer from '@/helpers/numberHumanizer';
import { useTooltipHide } from '@/hooks/useTooltipHide';


echarts.use([LineChart, TooltipComponent, GridComponent, LegendComponent]);
// نمودار CTR
const CtrChart = ({ data}) => {
  const chartRef = useRef();
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);

  // تنظیمات نمودار
  const getOption = () => ({
    textStyle: {
      fontFamily: 'dana'
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',

      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: params => {
        return `<div>
        <span>${params[0].marker}</span>
          <span class="fw-bolder">
          ${params[0].name}:
          </span>
          <span>${numberHumanizer(params[0].value)}</span>
          </div>`;
      },
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      type: 'value',
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisTick: { show: false },
      axisLabel: {
        color: getColor('gray-800'),
        formatter: value => value,
        margin: 15
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: 'category',
      data: Array.from({ length: 11 })
        .map((_, index) =>
          index === 10
            ? isMdUp
              ? `سایر`
              : '...'
            : isMdUp
              ? `رتبه ${index + 1}`
              : index + 1
        )
        .reverse(),
      axisLabel: {
        show: true,
        color: getColor('gray-800'),
        margin: 15
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisTick: { show: false },
      axisLine: { show: false }
    },
    series: [
      {
        type: 'bar',
        name: 'نمودار رتبه در',
        data: data,
        lineStyle: { color: getColor('primary') },
        showSymbol: false,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true
        }
      }
    ],
    grid: { right: '3%', left: '10%', bottom: '10%', top: '5%' }
  });

  return (
    <Card.Body>
      <ReactEChartsCore
        ref={chartRef}
        echarts={echarts}
        option={getOption()}
        style={{ height: '28rem' }}
      />
    </Card.Body>
  );
};
export default CtrChart;
